import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues2 } from 'components/BusinessToolForm/utils/helpers';

export const INVESTING_ACTIVITIES_NAMES = {
  PURCHASE_PROPERTY_PLANT_EQUIPMENT: 'purchasePropertyPlantEquipment',
  LOSS_ON_SALE_OF_ASSETS: 'lossOnSaleOfAssets',
  TABLE: 'table',
  TOTAL: 'total',
} as const;

export const useGetInvestingActivitiesTableHeadings = (isExamplePage: boolean) => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const investingActivitiesLinkedFields = {
      [INVESTING_ACTIVITIES_NAMES.PURCHASE_PROPERTY_PLANT_EQUIPMENT]: {
        name: '',
        title: t('financialPlan.projectedCashFlow.direct.investingActivities.purchasePropertyPlantEquipment'),
      },
      // TODO delete if client agreed
      // [INVESTING_ACTIVITIES_NAMES.LOSS_ON_SALE_OF_ASSETS]: {
      //   name: '',
      //   title: t('financialPlan.projectedCashFlow.direct.investingActivities.lossOnSaleOfAssets'),
      // },
    };

    const totalRowTitle = t(
      'financialPlan.projectedCashFlow.direct.investingActivities.netCashUsedInvestingActivities',
    );

    const investingActivitiesVariants = [
     isExamplePage ? 'Purchase of intangible and other non-current assets' : t('financialPlan.projectedCashFlow.direct.investingActivities.purchaseIntangibleNonCurrentAssets'),
     isExamplePage ? 'Purchases of investments' : t('financialPlan.projectedCashFlow.direct.investingActivities.purchaseInvestments'),
      isExamplePage ? 'Proceeds from sale of property, plant, and equipment' :t('financialPlan.projectedCashFlow.direct.investingActivities.proceedsSalePropertyPlantEquipment'),
     isExamplePage ? 'Proceeds from sale or maturity of investments' : t('financialPlan.projectedCashFlow.direct.investingActivities.proceedsSaleMaturityInvestments'),
     isExamplePage ? 'Receipt of government grants' : t('financialPlan.projectedCashFlow.direct.investingActivities.receiptGovernmentGrants'),
    ];
    return { investingActivitiesLinkedFields, totalRowTitle, investingActivitiesVariants };
  }, [t, i18n, isExamplePage]);
};

export const investingActivitiesLinkedFields = {
  [INVESTING_ACTIVITIES_NAMES.PURCHASE_PROPERTY_PLANT_EQUIPMENT]: {
    name: '',
    title: t('financialPlan.projectedCashFlow.direct.investingActivities.purchasePropertyPlantEquipment'),
  },
  // TODO delete if client agreed
  // [INVESTING_ACTIVITIES_NAMES.LOSS_ON_SALE_OF_ASSETS]: {
  //   name: '',
  //   title: t('financialPlan.projectedCashFlow.direct.investingActivities.lossOnSaleOfAssets'),
  // },
};

export const totalRowTitle = t(
  'financialPlan.projectedCashFlow.direct.investingActivities.netCashUsedInvestingActivities',
);

export const investingActivitiesVariants = [
  t('financialPlan.projectedCashFlow.direct.investingActivities.purchaseIntangibleNonCurrentAssets'),
  t('financialPlan.projectedCashFlow.direct.investingActivities.purchaseInvestments'),
  t('financialPlan.projectedCashFlow.direct.investingActivities.proceedsSalePropertyPlantEquipment'),
  t('financialPlan.projectedCashFlow.direct.investingActivities.proceedsSaleMaturityInvestments'),
  t('financialPlan.projectedCashFlow.direct.investingActivities.receiptGovernmentGrants'),
];

export interface IInvestingActivitiesType {
  [INVESTING_ACTIVITIES_NAMES.TABLE]: IPeriodsTableRow[];
  [INVESTING_ACTIVITIES_NAMES.TOTAL]: IPeriodsTableRow;
  // TODO delete if client agreed
  // [INVESTING_ACTIVITIES_NAMES.LOSS_ON_SALE_OF_ASSETS]: IPeriodsTableRow;
  [INVESTING_ACTIVITIES_NAMES.PURCHASE_PROPERTY_PLANT_EQUIPMENT]: IPeriodsTableRow;
}

export const investingActivitiesInitialValues: IInvestingActivitiesType = {
  [INVESTING_ACTIVITIES_NAMES.TABLE]: getFormTableInitialValues2(
    investingActivitiesVariants.length,
    initialPeriodsTableRow,
  ),
  // TODO delete if client agreed
  // [INVESTING_ACTIVITIES_NAMES.LOSS_ON_SALE_OF_ASSETS]: initialPeriodsTableRow,
  [INVESTING_ACTIVITIES_NAMES.PURCHASE_PROPERTY_PLANT_EQUIPMENT]: initialPeriodsTableRow,
  [INVESTING_ACTIVITIES_NAMES.TOTAL]: initialPeriodsTableRow,
};
